import {
  rasterizeNodeToPng,
  XHTML_NS,
} from '@terminal/views/alfred/research/utils/copyChartDom';

export const serializeElementToXhtml = (element: HTMLElement): string => {
  element.setAttribute('xmlns', XHTML_NS);
  const xhtml = new XMLSerializer().serializeToString(element);
  element.removeAttribute('xmlns');
  return xhtml;
};

interface RasterizeXhtmlToPngArgs {
  xhtml: string;
  width: number;
  height: number;
  fontCss?: string;
  timeoutMs?: number;
  trimPadding?: number;
}

export const rasterizeXhtmlToPng = async ({
  xhtml,
  width,
  height,
  fontCss = '',
  timeoutMs,
  trimPadding,
}: RasterizeXhtmlToPngArgs): Promise<string | undefined> => {
  if (!width || !height) {
    return undefined;
  }

  try {
    return await rasterizeNodeToPng({
      xhtml,
      width,
      height,
      fontCss,
      timeoutMs,
      trimPadding,
    });
  } catch {
    return undefined;
  }
};

interface RasterizeHtmlElementToPngArgs {
  element: HTMLElement;
  width: number;
  height: number;
  fontCss?: string;
  timeoutMs?: number;
  trimPadding?: number;
}

export const rasterizeHtmlElementToPng = ({
  element,
  ...args
}: RasterizeHtmlElementToPngArgs): Promise<string | undefined> =>
  rasterizeXhtmlToPng({
    xhtml: serializeElementToXhtml(element),
    ...args,
  });
